












import { bookGoodsModelProvider } from '../model'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      handleShareClick = () => {
        dcb.share({
          ...this.bookGoodsModel.value.shareParams,
          url: location.href,
        })
      }
    },
)
